import { Injectable } from '@angular/core';
import { FieldAgentClient, Attachment, AddProspectRequest, AddProspectWithIdAndCodeRequest } from 'ep-bt-field-agent-proxy';
import { BistrackConfig, ObjectListType } from 'ep-bt-controls';

@Injectable({
  providedIn: 'root'
})
export class EpbtFaProspectService {

  public sourceId: number;

  public sourceItemCode: string;

  constructor(private client: FieldAgentClient) { }

  getCustomerId(subscribe: (customerId: number) => void) {
    this.client.getCustomerID().subscribe(cusId => {
      subscribe(cusId);
    });
  }

  getCustomerCode(subscribe: (customerCode: string) => void) {
    this.client.getProspectCode().subscribe(cusCode => {
      subscribe(cusCode);
    });
  }

  deleteAttachmentsByAttachmentObj(attachment: Attachment,
    subscribe: (flag: boolean) => void) {
    this.client.deleteAttachment(attachment).subscribe(res => {
      subscribe(res);
      console.log('delete :' + res);
    });
  }
  getCustomerAttachmentsByCustomerID(customerId: number,
    subscribe: (customerAttachments: any) => void) {
    this.client.getObjectAttachments(customerId, ObjectListType.Customer).subscribe(res => {
      subscribe(res);
      console.log('attach :' + res);
    });
  }

  addCustomerProspectPost(addCustomerProspect: AddProspectRequest,
    subscribe: (cusCode: string) => void) {

    this.client.addProspect(addCustomerProspect).subscribe(res => {
      subscribe(res);
    });
  }

  AddCustomerProspectWithIdAndCode(addCustomerProspect: AddProspectWithIdAndCodeRequest,
    subscribe: (cusCode: string) => void) {

    this.client.addProspectWithIdAndCode(addCustomerProspect).subscribe(res => {
      subscribe(res);
    });
  }

}
